<input #inputField [value]="placeHolder" id="location-input" placeholder="Enter an address, city, state or zip code" required [attr.autocomplete]="'one-time-code'"/>
